import React from 'react';
import { motion } from 'framer-motion';
import { PalmTreeIcon, AxeIcon, GearIcon, LightningIcon, BroomIcon, TruckIcon } from './Icons';
const services = [{
  title: 'Tree & Palm Trimming',
  description: 'We trim all types of trees and palms — clean canopy, no more falling fronds, healthier trees, and better curb appeal',
  icon: PalmTreeIcon,
  color: 'bg-emerald-100 text-emerald-700'
}, {
  title: 'Tree Removal',
  description: "That tree that's been bothering you for years? Gone. Safely. Completely.",
  icon: AxeIcon,
  color: 'bg-red-100 text-red-700'
}, {
  title: 'Stump Grinding',
  description: 'No more ugly stumps, no more tripping hazards, clean flat ground',
  icon: GearIcon,
  color: 'bg-amber-100 text-amber-700'
}, {
  title: 'Emergency Service',
  description: 'Tree down right now? We respond day or night — no waiting until Monday',
  icon: LightningIcon,
  color: 'bg-orange-100 text-orange-700'
}, {
  title: 'Yard Cleanup',
  description: "We don't leave a trace — your yard is cleaner when we leave than when we arrived",
  icon: BroomIcon,
  color: 'bg-blue-100 text-blue-700'
}, {
  title: 'Hauling & Removal',
  description: 'We take everything with us. No pile left behind for you to deal with',
  icon: TruckIcon,
  color: 'bg-purple-100 text-purple-700'
}];
export const ServicesSection = () => {
  return <section id="services" className="py-24 bg-offwhite" data-id="element-276">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-277">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-278">
          <h2 className="text-3xl md:text-5xl font-bold text-charcoal mb-6" data-id="element-279">
            Here's Everything We Handle
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-280">
            So you never have to worry again.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-281">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100" data-id="element-282">
              <div className={`w-14 h-14 rounded-xl flex items-center justify-center mb-6 ${service.color}`} data-id="element-283">
                <service.icon className="w-7 h-7" data-id="element-284" />
              </div>
              <h3 className="text-2xl font-bold text-charcoal mb-4" data-id="element-285">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-286">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};